import { Button } from '@/components/ui/button'
import { Loader } from '@/components/ui/loader'
import styles from './PageState.module.scss'

export function LoadingPanel({ title }: { title: string }) {
  return (
    <section
      className="flex min-h-[50svh] items-center justify-center text-body-default text-foreground"
      aria-label={title}
    >
      <Loader variant="blocks" showLabel={false} size="xl" label={`Caricamento ${title}`} />
    </section>
  )
}

export function ErrorPanel({
  title,
  message,
  onRetry,
}: {
  title: string
  message: string
  onRetry?: () => void
}) {
  return (
    <section className="rounded-[var(--bank-radius-lg)] border border-border bg-card p-5 text-body-default text-foreground shadow-sm">
      <div className="flex flex-col gap-1">
        <div>
          <h2 className="text-section-title text-foreground">{title}</h2>
          <p className="text-body-default text-destructive">{message}</p>
        </div>
      </div>
      <div className="mt-5">
        <Button variant="outline" size="sm" onClick={onRetry ?? (() => window.location.reload())}>
          Riprova
        </Button>
      </div>
    </section>
  )
}

export function ComingSoonPanel({ title }: { title: string }) {
  return (
    <section className={styles.comingSoonPanel} aria-labelledby={`${title}-coming-soon-title`}>
      <div className={styles.comingSoonContent}>
        <p className={styles.kicker}>Pagina in arrivo</p>
        <h2 id={`${title}-coming-soon-title`} className={styles.comingSoonTitle}>
          {title}
        </h2>
        <p className={styles.comingSoonCopy}>
          Stiamo completando il workflow e verra pubblicata prossimamente.
        </p>
      </div>
    </section>
  )
}
